import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ShowMoreIcon from 'icon/chevron_down_fill.svg';
import { useViewTracking } from '~/utils/use-view-tracking';
import { ModuleType } from '~/utils/module-type';
import { ClickPosition } from '~/utils/click-position';
import useReflowClick from '~/utils/use-reflow-click';
import { useScopedAtomValue } from '@lemon8/web-app-shared/ssr';
import { PostDetailModalAtoms } from '~/components/post-detail-modal/atoms';
import { useActiveToArticle } from '~/utils/active/use-active-to-article';
import { $CurrentPositionPrefix } from '~/models/current-position-prefix';

import './style.scss';

export const CommentsSeeMore: FC = () => {
  const { t } = useTranslation();
  const article = useScopedAtomValue(PostDetailModalAtoms.$CurrentArticle);
  const activeToArticle = useActiveToArticle(article);
  const prefix = useScopedAtomValue($CurrentPositionPrefix);

  const { hasMore } = useScopedAtomValue(PostDetailModalAtoms.$CurrentArticleComments);

  const handleSeeMoreClick = useReflowClick(
    {
      defaultBehavior: () => {
        activeToArticle([prefix, ClickPosition.comment_see_more]);
      },
      reflowBehavior: () => {
        activeToArticle([prefix, ClickPosition.comment_see_more]);
      },
      clickEvent: () => ({
        current_position: prefix + ClickPosition.comment_see_more,
      }),
    },
    [activeToArticle],
  );

  const seeMoreObservedRef = useViewTracking({
    onView: useCallback(() => {
      window.Tea('wap_cta_show', {
        current_page_module: prefix + ModuleType.comment,
        current_position: prefix + ClickPosition.comment_see_more,
      });
    }, []),
  });

  if (!hasMore) {
    return null;
  }

  return (
    <div className="comments-see-more" ref={seeMoreObservedRef} onClick={handleSeeMoreClick}>
      <p>{t('seo_landing_cta_see_more_comments')}</p>

      <ShowMoreIcon className="chevron_down" />
    </div>
  );
};
